(() => {
  'use strict';

  const SAMPLE_PROPERTY_CLASS = 'af-temporary-sample-property';

  function findProductForm(service) {
    const formId = service.dataset.productFormId;

    if (!formId) return null;

    const element = document.getElementById(formId);

    if (!element) return null;

    // Je nach Craft-Version verweist die ID direkt auf das Formular
    // oder auf ein Element innerhalb des Formulars.
    if (element.matches('form')) return element;

    return element.closest('form') || element.querySelector('form');
  }

  function findSubmitButton(form) {
    return form.querySelector(
      'button[type="submit"][name="add"], ' +
      'button[type="submit"], ' +
      'input[type="submit"]'
    );
  }

  function addTemporaryProperty(form, name, value) {
    const input = document.createElement('input');

    input.type = 'hidden';
    input.name = `properties[${name}]`;
    input.value = value || '';
    input.className = SAMPLE_PROPERTY_CLASS;

    form.appendChild(input);
  }

  function removeTemporaryProperties(form) {
    form
      .querySelectorAll(`.${SAMPLE_PROPERTY_CLASS}`)
      .forEach((input) => input.remove());
  }

  function getSelectedVariantDetails(form) {
    const variantInput = form.querySelector('[name="id"]');

    const optionText = Array.from(
      form.querySelectorAll(
        'select option:checked, input[type="radio"]:checked'
      )
    )
      .map((input) => input.textContent?.trim() || input.value || '')
      .filter(Boolean)
      .join(' / ');

    return {
      input: variantInput,
      id: variantInput?.value || '',
      sku: variantInput?.dataset.sku || '',
      title:
        variantInput?.dataset.variantTitle ||
        optionText ||
        '',
    };
  }

  function restoreOriginalForm(
    form,
    variantInput,
    originalVariantId,
    submitButton
  ) {
    if (variantInput) {
      variantInput.value = originalVariantId;

      // Einige Themes beobachten Änderungen dieses Feldes.
      variantInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    removeTemporaryProperties(form);

    if (submitButton) {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-disabled');
    }
  }

  document.addEventListener('click', (event) => {
    const sampleButton = event.target.closest(
      '[data-af-sample-size]'
    );

    if (!sampleButton) return;

    event.preventDefault();

    const service = sampleButton.closest(
      '[data-af-sample-service]'
    );

    if (!service) return;

    const form = findProductForm(service);

    if (!form) {
      console.error(
        'ARTE FRESCA Sample Service: Product form not found.'
      );
      return;
    }

    const submitButton = findSubmitButton(form);
    const selectedVariant = getSelectedVariantDetails(form);
    const sampleVariantId =
      sampleButton.dataset.afSampleVariantId;
    const sampleSize =
      sampleButton.dataset.afSampleSize === 'small'
        ? 'Small'
        : 'Large';

    if (
      !submitButton ||
      !selectedVariant.input ||
      !sampleVariantId
    ) {
      console.error(
        'ARTE FRESCA Sample Service: Required cart elements are missing.'
      );
      return;
    }

    const originalVariantId = selectedVariant.id;
    const originalButtonContent = sampleButton.innerHTML;

sampleButton.disabled = true;
sampleButton.setAttribute('aria-busy', 'true');

    removeTemporaryProperties(form);

    addTemporaryProperty(
  form,
  service.dataset.sampleForLabel || 'Sample for',
  service.dataset.productTitle
);

    

    addTemporaryProperty(
  form,
  '_Product variant',
  selectedVariant.title
);

    addTemporaryProperty(
  form,
  '_Original SKU',
  selectedVariant.sku
);

    addTemporaryProperty(
  form,
  '_Product link',
  service.dataset.productUrl
);
addTemporaryProperty(
  form,
  '_Original image',
  service.dataset.productImage
);

    /*
      Das vorhandene echte Produktformular erhält vorübergehend
      die Muster-Variante. Kaching verarbeitet dadurch denselben
      Add-to-cart-Ablauf wie beim normalen Produkt.
    */
    selectedVariant.input.value = sampleVariantId;
    selectedVariant.input.dispatchEvent(
      new Event('change', { bubbles: true })
    );

    /*
      Ein echter Klick ist hier absichtlich besser als fetch():
      Kaching erkennt den vorhandenen Add-to-cart-Button
      und öffnet anschließend seinen Drawer.
    */
    submitButton.click();
    scheduleSampleCartStatusUpdate(900);
    sampleButton.innerHTML = `
  <span class="af-samples__added">
    <span class="af-samples__added-icon" aria-hidden="true">✓</span>
    <span>${service.dataset.addedText || 'Added'}</span>
  </span>
`;

    /*
      Nach kurzer Zeit wird das Formular wieder auf die zuvor
      ausgewählte Stoffvariante zurückgesetzt.
    */
    window.setTimeout(() => {
  restoreOriginalForm(
    form,
    selectedVariant.input,
    originalVariantId,
    submitButton
  );

  sampleButton.innerHTML = originalButtonContent;
  sampleButton.disabled = false;
  sampleButton.removeAttribute('aria-busy');
}, 2000);
  });
    function normalizeProductPath(value) {
    if (!value) return '';

    try {
      return new URL(value, window.location.origin)
        .pathname
        .replace(/\/$/, '');
    } catch (error) {
      return String(value).replace(/\/$/, '');
    }
  }

  async function updateSampleCartStatuses() {
    const services = document.querySelectorAll(
      '[data-af-sample-service]'
    );

    if (!services.length) return;

    try {
      const shopRoot =
        window.Shopify?.routes?.root || '/';

      const response = await fetch(`${shopRoot}cart.js`, {
        headers: {
          Accept: 'application/json',
        },
        cache: 'no-store',
      });

      if (!response.ok) {
        throw new Error(`Cart request failed: ${response.status}`);
      }

      const cart = await response.json();

      services.forEach((service) => {
        const currentProductPath = normalizeProductPath(
          service.dataset.productUrl
        );

        service
  .querySelectorAll('[data-af-sample-status]')
  .forEach((status) => {
    const sampleSize =
      status.dataset.afSampleStatus;

            const button = service.querySelector(
              `[data-af-sample-size="${sampleSize}"]`
            );

            const sampleVariantId =
              button?.dataset.afSampleVariantId || '';

            const isInCart = cart.items.some((item) => {
              const itemProductPath = normalizeProductPath(
                item.properties?.['Product link']
              );

              return (
                String(item.variant_id) ===
                  String(sampleVariantId) &&
                itemProductPath === currentProductPath
              );
            });

            status.hidden = !isInCart;
          });
      });
    } catch (error) {
      console.error(
        'ARTE FRESCA Sample Service: Cart status could not be checked.',
        error
      );
    }
  }

  let afSampleStatusTimer;

  function scheduleSampleCartStatusUpdate(delay = 300) {
    window.clearTimeout(afSampleStatusTimer);

    afSampleStatusTimer = window.setTimeout(() => {
      updateSampleCartStatuses();
    }, delay);
  }
  function enhanceSampleLinks() {
  const cartItems = document.querySelectorAll(
    'cart-drawer-items .cart-item, #CartDrawer .cart-item'
  );

  cartItems.forEach((cartItem) => {
    const productOptions = cartItem.querySelectorAll('.product-option');

    let sampleForValue = null;
let productLinkValue = cartItem.dataset.afProductLink || null;

    productOptions.forEach((option) => {
      const term = option.querySelector('dt');
      const description = option.querySelector('dd');

      if (!term || !description) return;

      const label = term.textContent.trim().toLowerCase();

      const propertyName =
  option.dataset.afPropertyName || '';

const sampleForPropertyNames = [
  'Sample for',
  'Muster für',
  'Échantillon pour',
  'Muestra de',
  'Campione per',
  'Próbka dla'
];

if (sampleForPropertyNames.includes(propertyName)) {
  sampleForValue = description;
}

if (
  propertyName === 'Product link' ||
  propertyName === '_Product link'
) {
  productLinkValue = description.textContent.trim();
  option.hidden = true;
}
    });
if (productLinkValue) {
  const sampleProductTitleLink = cartItem.querySelector(
    'a.cart-item__name'
  );

  if (sampleProductTitleLink) {
    sampleProductTitleLink.removeAttribute('href');
    sampleProductTitleLink.setAttribute(
      'aria-disabled',
      'true'
    );
    sampleProductTitleLink.style.pointerEvents = 'none';
    sampleProductTitleLink.style.cursor = 'default';
  }
}
    if (
      sampleForValue &&
      productLinkValue &&
      !sampleForValue.querySelector('a')
    ) {
      const link = document.createElement('a');

      link.href = productLinkValue;
      link.textContent = sampleForValue.textContent.trim();
      link.className = 'af-sample-original-product-link';

      sampleForValue.textContent = '';
      sampleForValue.appendChild(link);
    }
  });
}

const afSampleCartObserver = new MutationObserver(() => {
  enhanceSampleLinks();
  scheduleSampleCartStatusUpdate();
});

afSampleCartObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener('DOMContentLoaded', () => {
  enhanceSampleLinks();
  updateSampleCartStatuses();
});
document.addEventListener('click', () => {
  window.setTimeout(enhanceSampleLinks, 300);
});
})();